/* ANGULAR */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AngularFittextModule } from 'angular-fittext';

/* PHARMOX COMPONENT */
import { AppComponent } from './app.component';
import { AddLaboComponent } from './add-labo/add-labo.component';
import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from './app-routing.module';
import { AddPharmaComponent } from './add-pharma/add-pharma.component';
import { ListLaboComponent } from './list-labo/list-labo.component';
import { ListPharmaComponent } from './list-pharma/list-pharma.component';
import {ImageCropperModule} from 'ng2-img-cropper';

/* MODULE */
import { SharedModule } from './shared/shared.module';
import { OrderModule } from 'ngx-order-pipe';
import { AdminModule } from "./admin/admin.module";
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CurrencyMaskModule } from "ng2-currency-mask";

/* SERVICE */
import { AuthService } from './auth.service';

/* GUARD */
import { AuthGuard } from "./auth.guard";

/* DIRECTIVES */
import {EqualValidator} from "./shared/directives/equal-validator.directive";
import { ListCampaignComponent } from './list-campaign/list-campaign.component';
import { AddCampaignComponent } from './add-campaign/add-campaign.component';
import { RecapCampaignComponent } from './recap-campaign/recap-campaign.component';
import { ListContractComponent } from './list-contract/list-contract.component';
import { AddContractComponent } from './add-contract/add-contract.component';
import { ValidateContractComponent } from './validate-contract/validate-contract.component';
import { ValidateAccountComponent } from './validate-account/validate-account.component';
import { ListUserComponent } from './list-user/list-user.component';
import { DetailContractComponent } from './detail-contract/detail-contract.component';
import { ValidateCampaignComponent } from './validate-campaign/validate-campaign.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ListPromotionComponent } from './list-promotion/list-promotion.component';
import { AddProductComponent } from './add-product/add-product.component';
import { ListProductComponent } from './list-product/list-product.component';
import { DetailPromotionComponent } from './detail-promotion/detail-promotion.component';
import { ListOrderComponent } from './list-order/list-order.component';
import { DetailOrderComponent } from './detail-order/detail-order.component';
import { ListAdminComponent } from './list-admin/list-admin.component';
import { AddAdminComponent } from './add-admin/add-admin.component';
import { AddBillComponent } from './add-bill/add-bill.component';
import { ListBillComponent } from './list-bill/list-bill.component';
import { ValidateBillComponent } from './validate-bill/validate-bill.component';
import { DetailBillComponent } from './detail-bill/detail-bill.component';
import { NotificationCenterComponent } from './notification-center/notification-center.component';
import {CguComponent} from "app/cgu/cgu.component";
import {AddHashtingComponent} from "./add-hashting/add-hashting.component";
import {ListHashtingComponent} from "./list-hashting/list-hashting.component";
import {RecapHashtingComponent} from "./recap-hashting/recap-hashting.component";


@NgModule({
  declarations: [
    AppComponent,
    AddLaboComponent,
    LoginComponent,
    CguComponent,
    AddPharmaComponent,
    ListLaboComponent,
    ListPharmaComponent,
    EqualValidator,
    ListCampaignComponent,
    AddCampaignComponent,
    RecapCampaignComponent,
    AddHashtingComponent,
    ListHashtingComponent,
    RecapHashtingComponent,
    ListContractComponent,
    AddContractComponent,
    ValidateContractComponent,
    ValidateAccountComponent,
    ListUserComponent,
    DetailContractComponent,
    ValidateCampaignComponent,
    ForgotPasswordComponent,
    ListPromotionComponent,
    AddProductComponent,
    ListProductComponent,
    DetailPromotionComponent,
    ListOrderComponent,
    DetailOrderComponent,
    ListAdminComponent,
    AddAdminComponent,
    AddBillComponent,
    ListBillComponent,
    ValidateBillComponent,
    DetailBillComponent,
    NotificationCenterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AngularFittextModule,
    OrderModule,
    AppRoutingModule,
    SharedModule,
    AdminModule,
    TagInputModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatNativeDateModule,
    ImageCropperModule,
    CurrencyMaskModule,
    NgCircleProgressModule.forRoot({
      titleFontSize: '12px',
      backgroundOpacity: 1,
      backgroundStrokeWidth: 7,
      backgroundPadding: 0,
      radius: 25,
      space: 2,
      toFixed: 0,
      maxPercent: 100,
      outerStrokeWidth: 1,
      outerStrokeLinecap: "inherit",
      innerStrokeWidth: 1,
      innerStrokeColor: "#c7cdcc",
      showInnerStroke: true
    })
  ],
  providers: [
    FormBuilder,
    AuthGuard,
    AuthService,
    EqualValidator
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts